import React from "react"

export default () => {
  return {
    renderMark(props, editor, next) {
      const { children, mark, attributes } = props
      switch (mark.type) {
        case "bold":
          return <strong {...attributes}>{children}</strong>
        case "italic":
          return <em {...attributes}>{children}</em>
        case "underline":
          return <u {...attributes}>{children}</u>
        case "strikethrough":
          return <s {...attributes}>{children}</s>
        case "inline-code":
          return <code {...attributes}>{children}</code>
        default:
          return next()
      }
    }
  }
}
